



































































































































































































































import { Vue, Component } from 'vue-property-decorator';

import { Surface } from '@/components/atoms';
import DiscountOffer from '@/components/molecules/DiscountOffer/DiscountOffer.vue';
import PhoneMockup from '@/componentsV2/molecules/PhoneMockup/PhoneMockup.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import LazyImage from '@/componentsV2/atoms/LazyImage/LazyImage.vue';

// ICONS
import ExternalLink from '@/components/icons/ExternalLink.vue';
import MapPin from '@/components/icons/MapPin.vue';
import Phone from '@/components/icons/Phone.vue';
import Instagram from '@/components/icons/Instagram.vue';
import Facebook from '@/components/icons/Facebook.vue';
import Website from '@/components/icons/Website.vue';
import Arrow from '@/components/icons/Arrow.vue';
import ArrowUploadIcon from '@/components/icons/ArrowUpload.vue';

import { IBusinessType } from '@/models/business';
import {
  EOfferRulesName,
  EOfferTypeEnum,
  ESpecialOfferRules,
  IOfferMethod,
  getRedeemableString,
  getRenewedValue
} from '@/models/offer';

import DateUtils from '@/utils/DateUtils';
import { renderTextWithLinks } from '@/utils/renderTextWithLinks';

import { SPECIAL_OFFER_PREVIEW_STORAGE_KEY } from '@/store/modules/offer';

import flagKeys from '@/constants/flagKeys';

import ImageSpecialCoinPreview from '../ImageSpecialCoinPreview.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';

@Component({
  components: {
    Surface,
    ImageSpecialCoinPreview,
    DiscountOffer,
    ExternalLink,
    MapPin,
    Phone,
    Instagram,
    Facebook,
    Website,
    PhoneMockup,
    Typography,
    LazyImage,
    Arrow,
    ArrowUploadIcon,
    Page
  }
})
export default class AppPreview extends Vue {
  offer: any = {};

  get tPrefix() {
    return 'offers';
  }

  get tPrefixPreview() {
    return `${this.tPrefix}.preview`;
  }

  get tPrefixApp() {
    return `${this.tPrefixPreview}.app`;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get restrictionFieldIsActivated() {
    return this.flags.includes(flagKeys.offerRestrictionField);
  }

  get redeemableTimeLabel() {
    return getRedeemableString(
      this.rules[EOfferRulesName.REDEEMABLE_DAY_RULE].value || '',
      this.rules[EOfferRulesName.REDEEMABLE_HOUR_RULE].value || ''
    );
  }

  get maxRedmeedRule() {
    const { rulesOverview } = this.offer;
    if (rulesOverview) {
      const rule = rulesOverview[ESpecialOfferRules.SUPPLY_RULE];
      if (rule && rule.value) {
        return `<strong>${rule.value}</strong> out of <strong>${
          rule.value
        }</strong> remaining`;
      }
    }

    return false;
  }

  get coinsLabel() {
    if (this.isBirthdayOffer) {
      return this.$t(`${this.tPrefix}.form.coinRule.overviewApp`, {
        coinLimit: 1,
        coin: this.$tc('common.pluralize.coin', 1)
      });
    }

    const coinLimit = this.rules[ESpecialOfferRules.LIMIT_RULE];
    if (!coinLimit || !coinLimit.value || !coinLimit.enabled) return '';

    return this.$t(`${this.tPrefix}.form.coinRule.overviewApp`, {
      coinLimit: coinLimit.value,
      coin: this.$tc('common.pluralize.coin', coinLimit.value)
    });
  }

  get renewedLabel() {
    if (!this.rules || !this.rules[ESpecialOfferRules.RENEWED_RULE]) return '';

    const renewedLimit = getRenewedValue(
      this.rules[ESpecialOfferRules.RENEWED_RULE].value
    );

    return this.$t(`${this.tPrefix}.form.renewedRule.overview`, {
      period: renewedLimit.periodFormatted,
      time: renewedLimit.time === '1' ? '' : ` ${renewedLimit.time}`
    });
  }

  get redeemableLabel() {
    const labelMapper: Record<IOfferMethod, string> = {
      [IOfferMethod.BOTH]: String(
        this.$t(`${this.tPrefix}.form.otherRules.redeemableOnlineAndInStoreApp`)
      ),
      [IOfferMethod.INSTORE]: String(
        this.$t(`${this.tPrefix}.form.otherRules.redeemableInStoreApp`)
      ),
      [IOfferMethod.ONLINE]: String(
        this.$t(`${this.tPrefix}.form.otherRules.redeemableOnlineApp`)
      )
    };

    if (!labelMapper[this.offer.method as IOfferMethod]) return '';

    return labelMapper[this.offer.method as IOfferMethod];
  }

  get isBirthdayOffer() {
    return this.offer && this.offer.type === EOfferTypeEnum.BIRTHDAY;
  }

  get expirationLabel() {
    if (this.isBirthdayOffer) {
      return this.$t(`${this.tPrefix}.form.expirationRule.overviewBirthdayApp`);
    }

    const expiration = this.rules[ESpecialOfferRules.EXPIRATION_RULE];
    if (!expiration || !expiration.value || !expiration.enabled) return '';

    return this.$t(`${this.tPrefix}.form.expirationRule.overview`, {
      date: DateUtils.formattedDate({ date: expiration.value })
    });
  }

  get expirationLabelHeader() {
    if (this.isBirthdayOffer) {
      return this.$t(`${this.tPrefix}.form.expirationRule.overviewBirthdayApp`);
    }

    const expiration = this.rules[ESpecialOfferRules.EXPIRATION_RULE];
    if (!expiration || !expiration.value || !expiration.enabled) return '';

    return `Expires on <strong>${DateUtils.formattedDate({
      date: expiration.value
    })}</strong>`;
  }

  get combinedLabel() {
    if (this.isBirthdayOffer) {
      return this.$t(`${this.tPrefix}.form.combineRule.overviewApp`);
    }

    const combined = this.rules[ESpecialOfferRules.COMBINED_RULE];
    if (!combined || !combined.enabled) return '';

    return this.$t(`${this.tPrefix}.form.combineRule.overviewApp`);
  }

  get restrictions() {
    if (this.offer.restrictions && this.restrictionFieldIsActivated) {
      return this.offer.restrictions
        .split(';')
        .filter(Boolean)
        .map((text: string) => renderTextWithLinks(text, true));
    }

    return [];
  }

  get rules() {
    return this.offer.rulesOverview;
  }

  get title() {
    if (!this.offer.title)
      return this.$t(
        `${this.tPrefix}.form.titlePlaceholder.${this.offer.productType ||
          this.offer.specialType}`
      );
    return this.offer.title;
  }

  get description() {
    return renderTextWithLinks(this.offer.description, true);
  }

  get businessName() {
    let businessName = this.business.name;
    if (this.business.type !== 'online') businessName += ' • 1.5 mi';
    return businessName;
  }

  get businessLocations() {
    if (!this.business.businessLocations) return [];
    return this.business.businessLocations;
  }

  get business() {
    return this.$store.getters['business/getBusinessState'];
  }

  get onlineOnly() {
    return this.business.type === IBusinessType.ONLINE;
  }

  getLocationName(location: any) {
    const { address, city, state } = location;
    return `${address}, ${city}, ${state}`;
  }

  created() {
    const storageOffer = localStorage.getItem(
      SPECIAL_OFFER_PREVIEW_STORAGE_KEY
    );

    if (storageOffer) {
      this.offer = JSON.parse(storageOffer);
      return;
    }

    if (this.$route.query.offer) {
      this.offer = JSON.parse(this.$route.query.offer as string);
      return;
    }
    this.offer = {
      productType: 'specific-product',
      discount: {},
      rulesOverview: {}
    };
    return;
  }
}
